import handler from '@/components/goods/handler/storage';
import category from '@/components/goods/category/storage';
import _export from '@/components/goods/export/storage';
import edit from '@/components/goods/edit/storage';

export default {
    namespaced: true,
    modules: {
        handler,
        category,
        _export,
        edit
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}